if (document.querySelector('.swiper-front-hero')) {
    const swiperBanner = new Swiper('.swiper-front-hero', {
        slidesPerView: 1,
        speed: 1000,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 6000,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
}
if (document.querySelector('.swiper-info')) {
    const swiperInfo = new Swiper('.swiper-info', {
        slidesPerView: 1,
        speed: 1000,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 3000,
        },
    });
}
if (document.querySelector('.swiper-promo-cetasdi')) {
    const swiperPromo = new Swiper('.swiper-promo-cetasdi', {
        slidesPerView: 1,
        speed: 1000,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        // autoplay: {
        //     delay: 3000,
        // },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
}
if (document.querySelector('.swiper-blog-home')) {
    const swiperBlogHome = new Swiper('.swiper-blog-home', {
        slidesPerView: 1,
        spaceBetween: 40,
        loop: true,
        autoplay: {
            delay: 3000,
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
            },
            640: {
                slidesPerView: 2,
            },
            940: {
                slidesPerView: 3,
            },
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
}
if (document.querySelector('.swiper-testimonial')) {
    const swiperTestimonials = new Swiper('.swiper-testimonial', {
        slidesPerView: 1,
        spaceBetween: 40,
        autoplay: {
            delay: 3000,
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
            },
            640: {
                slidesPerView: 2,
            },
            940: {
                slidesPerView: 3,
            },
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
}

if (document.querySelector('.swiper-convenio')) {
    const swiperConvenio = new Swiper('.swiper-convenio', {
        slidesPerView: 1,
        spaceBetween: 40,
        loop: true,
        autoplay: {
            delay: 2500,
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
            },
            640: {
                slidesPerView: 4,
            },
            940: {
                slidesPerView: 6,
            },
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
}